module.exports = __webpack_public_path__ + "img/cocoa.be5030ca.webp";